/**
 * Rankings page scripts
 */
document.addEventListener('DOMContentLoaded', () => {
  // Obserwator animacji pojawiania się elementów na osi czasu (jeśli wspierane)
  if ('IntersectionObserver' in window) {
    const items = document.querySelectorAll('.rankings-item');
    if (!items.length) {
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.15,
      },
    );

    items.forEach((item) => observer.observe(item));
  }
});
